/**
 * A stable, muted colour derived from a game's title.
 *
 * Used as the backdrop behind a capsule while its art loads, and as the
 * permanent background for the handful of games that have no portrait art at
 * all. A wall of identical grey rectangles is the ugliest possible loading
 * state; this gives each slot its own quiet colour for free.
 *
 * Deliberately not called a "dominant colour" — it is not sampled from the
 * artwork, just derived from the title, so it is consistent across reloads
 * without any image decoding.
 */
export function tintFromString(input: string): string {
  let hash = 0
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash << 5) - hash + input.charCodeAt(i)
    hash |= 0
  }

  const hue = Math.abs(hash) % 360

  // Low saturation and lightness so it reads as a surface, never as content.
  return `hsl(${hue} 24% 13%)`
}

/** Initials shown on art-less capsules, e.g. "Dear Esther" -> "DE". */
export function initialsFromTitle(title: string): string {
  return title
    .split(/[\s:—-]+/)
    .filter((word) => /[a-z0-9]/i.test(word))
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? '')
    .join('')
}
